export const unify = (str: string | number, suffix: string | number) => {
  return `${str}${suffix}`
}

export const deunify = (str: string, suffix: string | number) => {
  return str.slice(0, str.length - suffix.toString().length)
}
